<template>
  <v-app id="base">
    <AppBar v-if="!hideAppBar" :isDrawerHidden="hideDrawer" :showHome="showHome" />

    <!-- <Drawer v-if="!hideDrawer" /> -->

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from "./components/AppBar";
import Drawer from "./components/Drawer";

export default {
  name: "App",

  components: {
    AppBar,
    Drawer,
  },

  data: () => ({
    currentRouteName: "",
    routeConfigs: {
      "sign-in": {
        "title": "Login",
        "hideDrawer": true,
        "hideAppBar": true
      },
      "default": {
        "title": "View Title",
      },
      "tracker-details": {},
      "calculator": {
				showHome: true,
			},
      "tracker-form": {
        showHome: true,
      },
      "test-create-invoice": {},
    },
  }),

  mounted: function () {
    this.currentRouteName = this.$route.name;
  },

  watch: {
    $route(to) {
      this.currentRouteName = to.name;
    }
  },

  computed: {
    currentRouteConfig: function () {
      return this.routeConfigs[this.currentRouteName] || null;
    },
    isAuthenticated: function () {
      return !!this.$store.state.authToken
    },
    showHome: function () {
      if (this.currentRouteConfig && this.currentRouteConfig.showHome) {
        return true;
      }
      return false;
    },
    hideDrawer: function () {
      if (!this.currentRouteConfig || this.currentRouteConfig.hideDrawer) {
        return true;
      }
      return false;
    },
    hideAppBar: function () {
      if (!this.currentRouteConfig || this.currentRouteConfig.hideAppBar) {
        return true;
      }
      return false;
    }
  },

  methods: {
  },
};
</script>

<style lang="scss" scoped></style>
